import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import clsx from 'clsx'
import { camelCase } from 'lodash'
import { formatRoute } from 'react-router-named-routes'
import { useTranslation } from 'react-i18next'

/* components */
import { API_URL } from 'constants/main'

/* styles */
import classes from 'pages/sheared/Categories/Category/index.module.scss'
import routes from '../../../../constants/routes'

const Category = ({
  name,
  icon,
  slug,
}) => {
  const { t } = useTranslation('home_volunteering')

  return (
    <div className={classes.categoryWrapper}>
      <NavLink to={{ pathname: formatRoute(routes.theme, { slug }) }} className={classes.categoryLink}>

        <img
          src={`${API_URL}${icon}`}
          alt={name}
        />

        <div className={clsx(classes.categoryTitle, 'ml-8')}>
          {t(camelCase(name))}
        </div>

      </NavLink>
    </div>
  )
}


Category.propTypes = {
  name: PropTypes.string,
  icon: PropTypes.string,
  slug: PropTypes.string,
}

export default Category
